import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import { SessionStatus } from "@/store/sessions/types";
import { mdsColors } from "@/design-system/foundations";
import { css, cx } from "@/domains/emotion";

interface SessionStatusIconProps {
  status: SessionStatus;
}
export const SessionStatusIcon: React.FC<SessionStatusIconProps> = ({ status }) => {
  switch (status) {
    case "PROCESSING":
      return <MdsIcon kind={MdsIconKind.Spinner} className={iconStyles} />;
    case "FINISHED":
      return (
        <MdsIcon
          kind={MdsIconKind.CheckCircleSolid}
          className={cx(iconStyles, successIconStyles)}
        />
      );
    case "ERROR":
      return (
        <MdsIcon kind={MdsIconKind.ExclamationSolid} className={cx(iconStyles, errorIconStyles)} />
      );
  }
};

const iconStyles = css({
  width: "32px",
});

const successIconStyles = css({
  color: mdsColors().green.x500,
});

const errorIconStyles = css({
  color: mdsColors().red.x500,
});
